import { render, staticRenderFns } from "./EditTeamTaskForm.vue?vue&type=template&id=8fcafc08&scoped=true&lang=pug&"
import script from "./EditTeamTaskForm.vue?vue&type=script&lang=js&"
export * from "./EditTeamTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcafc08",
  null
  
)

export default component.exports